import { NewBadge } from "shared/app/NewBadge";
import { NAV_SECTION_CLASS_NAME, NavItemId } from "../constants";
import { ResolvedNavItem } from "../nav-settings";
import { useNavCustomization } from "../use-nav-customization";
import { InboxNavLink } from "./InboxNavLink";
import { NavLink } from "./NavLink";
import { NavSectionHeader } from "./NavSectionHeader";
import { NotificationsNavLink } from "./NotificationsNavLink";
import { RentReportingNavLink } from "./RentReportingNavLink";
import { UnitsNavLink } from "./UnitsNavLink";

const NavItemLink = ({ item }: { item: ResolvedNavItem }) => {
  if (item.id === NavItemId.NOTIFICATIONS)
    return (
      <NotificationsNavLink name={item.name} to={item.to} Icon={item.Icon} />
    );

  if (item.id === NavItemId.INBOX)
    return <InboxNavLink name={item.name} to={item.to} Icon={item.Icon} />;

  if (item.id === NavItemId.UNITS)
    return <UnitsNavLink name={item.name} to={item.to} Icon={item.Icon} />;

  if (item.id === NavItemId.RENT_REPORTING)
    return (
      <RentReportingNavLink name={item.name} to={item.to} Icon={item.Icon} />
    );

  if (item.isNew)
    return (
      <NavLink
        to={item.to}
        HugeIcon={item.Icon}
        strokeWidth={item.strokeWidth}
        isBeta={item.isBeta}
      >
        <span className="flex items-center gap-2">
          {item.name}
          <NewBadge destructAfterDate={item.newUntil} />
        </span>
      </NavLink>
    );

  return (
    <NavLink
      to={item.to}
      HugeIcon={item.Icon}
      strokeWidth={item.strokeWidth}
      isBeta={item.isBeta}
    >
      {item.name}
    </NavLink>
  );
};

export const NavSections = () => {
  const { sections } = useNavCustomization();

  return sections.map((section) => {
    const visibleItems = section.items.filter(({ isHidden }) => !isHidden);
    if (!visibleItems.length) return null;

    return (
      <div key={section.id} className={NAV_SECTION_CLASS_NAME[section.id]}>
        <NavSectionHeader section={section} />
        {visibleItems.map((item) => (
          <NavItemLink key={item.id} item={item} />
        ))}
      </div>
    );
  });
};
